/**
 * CRE-11 material type filters for category / subcategory pickers.
 *
 * Virgin catalog is the default for product flows.
 * Use ALL_CATEGORIES_FILTER only on category/subcategory admin CRUD screens.
 * Use REPROCESSED_* filters only on the reprocessed product recycle flow.
 */

/** Virgin-only categories (default for products, pricing, import, etc.) */
export const VIRGIN_CATEGORY_FILTER = { is_virgin: true } as const;

/** Show every category/subcategory (admin master lists and CRUD) */
export const ALL_CATEGORIES_FILTER = { all: true } as const;

/** Reprocessed-only categories (product recycle flow) */
export const REPROCESSED_CATEGORY_FILTER = { is_reprocessed: true } as const;

/** Reprocessed-only subcategories for a parent category */
export const reprocessedSubcategoriesByCategoryFilter = (
    categoryId: number | string
) => ({
    category_id: categoryId,
    reprocessed_only: true,
});

/** Virgin-only subcategories for a parent category */
export const virginSubcategoriesByCategoryFilter = (
    categoryId: number | string
) => ({
    category_id: categoryId,
    is_virgin: true,
});
